import { onBeforeUnmount } from 'vue'
import { processedQueues, startAgentTracking, stopAgentTracking } from '@/composables/useQueueAgentsComposable'
import useGlobalUniqueID from '@/composables/useUniqueId'

export function useQueueAgentsInline () {
    const uid = `queue-agents-inline-${useGlobalUniqueID()}`

    startAgentTracking(uid)

    onBeforeUnmount(() => {
        stopAgentTracking(uid)
    })

    function getAgents () {
        const { allAvailable, allUnavailable } = processedQueues.value
        return {
            allAvailable,
            allUnavailable
        }
    }

    return { getAgents }
}
